
import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL +  "/api/Upload/UploadFile/";

export default function uploadImg(obj) {
  let formData = new FormData();
  formData.append("file", obj);
  return http.post(apiEndpoint, formData);
}
